import { render, staticRenderFns } from "./Webhuset.vue?vue&type=template&id=4c6fcd1e"
import script from "./Webhuset.vue?vue&type=script&lang=js"
export * from "./Webhuset.vue?vue&type=script&lang=js"
import style0 from "./Webhuset.vue?vue&type=style&index=0&id=4c6fcd1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports